<!-- Modal -->
<div class="modal show" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-body">
			<div class="modal-content modal-bg-wallet">
				<div class="modal-header">
					<h4 class="modal-title" id="myModalLabel"><img src="/assets/images/bottom-icn-wallet.png" width="30"> {{ 'Common.Transfer' | translate}} </h4>
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseDialog()">×</button>
				</div>
				<div class="modal-body">
          <app-transfer-modal [isPerProvider]="true"></app-transfer-modal>
        </div>
			</div>
		</div>
	</div>
</div>

